import { Component, Input } from '@angular/core';

@Component({
  selector: 'bs-library-icon',
  imports: [],
  template: `
  <svg id="library-icon" [style.width.px]="width" [style.height.px]="height" [style.fill]="iconFill" [style.stroke]="iconFill" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72">
    <rect x="6.083" y="12.517" width="12.167" height="55.883" style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <rect x="29.417" y="17.587" width="11.583" height="50.813" style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <rect x="51.833" y="8.9" width="14.167" height="59.5" style="fill: none; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <line x1="6.083" y1="22.833" x2="17" y2="22.833" style="fill: none; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <line x1="6.667" y1="30.167" x2="17.417" y2="30.167" style="fill: none; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <line x1="6.667" y1="61.667" x2="18.25" y2="61.667" style="fill: none; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <line x1="6.667" y1="54.917" x2="17.417" y2="54.917" style="fill: none; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <line x1="35.208" y1="31.042" x2="35.208" y2="21.417" style="fill: none; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <line x1="35.208" y1="53.994" x2="35.208" y2="32.375" style="fill: none; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <line x1="55.229" y1="58.167" x2="62.604" y2="58.167" style="fill: none; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <line x1="56.729" y1="63" x2="62" y2="63" style="fill: none; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <line x1="52" y1="18.958" x2="66" y2="18.958" style="fill: none; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <line x1="52.417" y1="22.833" x2="66.417" y2="22.833" style="fill: none; stroke-miterlimit: 10; stroke-width: 2px;"/>
  </svg>
  `,
  styles: `
    .icon-fill {
      fill: var(--p-bs-icon-color);
    }`,
  standalone: true
})
export class BsLibraryIconComponent {
  @Input() width: number = 30;
  @Input() height: number = 30;
  @Input() iconFill: string = 'var(--p-bs-icon-color)';
}
